import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import GeetzLogin from '../../assets/GeetzLogo';
import Button from '../../components/Button';
import { useTheme } from '../../contexts/theme'; // Import useTheme hook

import { IconLock, IconUser } from '@tabler/icons-react';
import InputLogin from '../../components/InputLogin';
import { useAuth } from '../../contexts/auth';
import {
  BackgroundImg,
  BottomContainer,
  CadastroContainer,
  CadastroTexts,
  Href,
  InputContainer,
  LogoWrapper,
  SocialButton,
  SocialButtonText,
  SocialContainer,
  Text,
  Text2
} from './styles';

import Artboard2 from '../../assets/LoginBackground/Artboard2.png';
const IconGoogle = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3603_525)">
      <path d="M24.2663 12.9139C24.2663 12.0982 24.2001 11.2781 24.059 10.4756H12.7402V15.0966H19.222C18.953 16.5869 18.0888 17.9053 16.8233 18.7431V21.7414H20.6903C22.9611 19.6514 24.2663 16.5649 24.2663 12.9139Z" fill="#4285F4" />
      <path d="M12.7401 24.6385C15.9766 24.6385 18.7059 23.5759 20.6945 21.7416L16.8276 18.7432C15.7517 19.4752 14.3627 19.8897 12.7445 19.8897C9.61388 19.8897 6.95946 17.7776 6.00705 14.938H2.0166V18.0289C4.05371 22.0811 8.2029 24.6385 12.7401 24.6385Z" fill="#34A853" />
      <path d="M6.00277 14.9379C5.50011 13.4476 5.50011 11.8337 6.00277 10.3434V7.25244H2.01674C0.314734 10.6432 0.314734 14.6381 2.01674 18.0288L6.00277 14.9379Z" fill="#FBBC04" />
      <path d="M12.7401 5.38736C14.4509 5.3609 16.1044 6.00466 17.3434 7.18636L20.7695 3.76031C18.6001 1.7232 15.7208 0.603229 12.7401 0.638504C8.2029 0.638504 4.05371 3.19592 2.0166 7.2525L6.00264 10.3434C6.95064 7.49943 9.60947 5.38736 12.7401 5.38736Z" fill="#EA4335" />
    </g>
    <defs>
      <clipPath id="clip0_3603_525">
        <rect width="24" height="24" fill="white" transform="translate(0.5 0.637695)" />
      </clipPath>
    </defs>
  </svg>
)

const IconApple = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3603_2966)">
      <path d="M21.3428 17.7824C21.0101 18.551 20.6163 19.2585 20.16 19.909C19.5381 20.7957 19.0288 21.4095 18.6364 21.7504C18.028 22.3099 17.3762 22.5964 16.6782 22.6127C16.1771 22.6127 15.5728 22.4701 14.8693 22.1809C14.1636 21.893 13.515 21.7504 12.922 21.7504C12.3 21.7504 11.633 21.893 10.9195 22.1809C10.2049 22.4701 9.62928 22.6209 9.18916 22.6358C8.51981 22.6643 7.85264 22.3696 7.18668 21.7504C6.76164 21.3797 6.22999 20.7441 5.59309 19.8438C4.90976 18.8823 4.34796 17.7674 3.90784 16.4964C3.43648 15.1234 3.2002 13.794 3.2002 12.5069C3.2002 11.0325 3.51878 9.7609 4.15689 8.69529C4.6584 7.83936 5.32557 7.16417 6.16059 6.6685C6.99562 6.17284 7.89786 5.92025 8.86949 5.90409C9.40114 5.90409 10.0983 6.06855 10.9647 6.39175C11.8287 6.71603 12.3834 6.88048 12.6266 6.88048C12.8085 6.88048 13.4247 6.68819 14.4694 6.30483C15.4573 5.94931 16.2911 5.80211 16.9742 5.8601C18.8251 6.00947 20.2157 6.73912 21.1405 8.05365C19.4851 9.05665 18.6662 10.4615 18.6825 12.2637C18.6975 13.6674 19.2067 14.8356 20.2076 15.7631C20.6611 16.1935 21.1676 16.5262 21.7312 16.7625C21.609 17.117 21.48 17.4565 21.3428 17.7824ZM17.0978 1.07782C17.0978 2.17807 16.6958 3.20537 15.8946 4.15623C14.9277 5.28662 13.7582 5.93981 12.49 5.83674C12.4738 5.70474 12.4645 5.56582 12.4645 5.41984C12.4645 4.3636 12.9243 3.23321 13.7408 2.30897C14.1485 1.84101 14.667 1.4519 15.2957 1.14151C15.9231 0.835746 16.5166 0.666652 17.0747 0.637695C17.091 0.784782 17.0978 0.931877 17.0978 1.07781V1.07782Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_3603_2966">
        <rect width="24" height="24" fill="white" transform="translate(0.5 0.637695)" />
      </clipPath>
    </defs>
  </svg>
)
export default function Login() {
  const { token, signIn } = useAuth();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { themeColors } = useTheme();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showpass, setShowpass] = useState(false)

  async function handleSubmitLogin() {
    const data = {
      identifier: email,
      password: password
    }
    await signIn(data)
    navigate('/')
  }

  return (
    <>
      <BackgroundImg src={Artboard2} alt='Background Image' />
      <LogoWrapper>
        <GeetzLogin />
      </LogoWrapper>
      <CadastroContainer>
        <div style={{ gap: '2px' }}>
          <CadastroTexts>Chega mais!</CadastroTexts>
          <Text2>
            Bem vindo de volta ao nosso mundo.
          </Text2>
        </div>
        <InputContainer onSubmit={handleSubmitLogin}>
          <InputLogin icon={<IconUser size={24} color={"#A0A0A0"} />} placeholder={'Usuário ou email'} handler={(e) => setEmail(e.target.value)} />
          <InputLogin icon={<IconLock size={24} color={"#A0A0A0"} />} placeholder={t('cadastro.password')} handler={(e) => setPassword(e.target.value)} type={showpass ? "text" : "password"} />
        </InputContainer>
        <BottomContainer>
          <Text>
            <Href style={{ cursor: 'pointer' }} >Esqueceu a senha?</Href>
          </Text>
          <Button
            height={"42"}
            theme="dark"
            text={'Entrar'}
            onClick={handleSubmitLogin}
          />
        </BottomContainer>
        <SocialContainer>
          <SocialButton>
            <IconGoogle />
            <SocialButtonText>Cadastre-se com Google</SocialButtonText>
          </SocialButton>
          <SocialButton>
            <IconApple />
            <SocialButtonText>Cadastre-se com Apple</SocialButtonText>
          </SocialButton>
        </SocialContainer>
        <Text2 >
          Não possui cadastro? <Href style={{ cursor: 'pointer' }} onClick={() => window.location.href = '/cadastro'}>Cadastre-se.</Href>
        </Text2>
      </CadastroContainer>
    </>
  );
}